import React, { useState } from 'react';
import { useQuery, gql } from '@apollo/client';
import GwaEnrollModal from './GwaEnrollModal';
import GwaDashboard from './GwaDashboard';
import styles from './Gwa.module.scss';

export const GWA_PROGRAM_QUERY = gql`
  query RESCUE_gwaProgram {
    rescueGwaProgram {
      id
      slug
      promoCodeAlias
      pdpUrl
      active
      createdAt
      totalRedemptions
      monthRedemptions
      recentRedemptions {
        id
        petName
        adopterName
        breed
        age
        redeemedAt
      }
    }
  }
`;

export interface GwaRedemptionItem {
  id: string;
  petName: string | null;
  adopterName: string;
  breed: string | null;
  age: string | null;
  redeemedAt: string;
}

interface GwaProgramData {
  rescueGwaProgram: {
    id: string;
    slug: string;
    promoCodeAlias: string;
    pdpUrl: string;
    active: boolean;
    createdAt: string;
    totalRedemptions: number;
    monthRedemptions: number;
    recentRedemptions: GwaRedemptionItem[];
  } | null;
}

export default function Gwa() {
  const { data, loading, error, refetch } = useQuery<GwaProgramData>(GWA_PROGRAM_QUERY);
  const [modalDismissed, setModalDismissed] = useState(false);

  if (loading) {
    return (
      <div>
        <h1>Gift with Adoption</h1>
        <div className={styles.loading}>Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h1>Gift with Adoption</h1>
        <div className={styles.emptyState}>
          <p>Something went wrong loading your GWA program. Please try refreshing.</p>
        </div>
      </div>
    );
  }

  const enrollment = data?.rescueGwaProgram;

  if (enrollment) {
    return <GwaDashboard enrollment={enrollment} />;
  }

  // Modal is open by default when not enrolled, unless user explicitly dismissed it
  const modalOpen = !modalDismissed;

  return (
    <div>
      <h1>Gift with Adoption</h1>
      <div className={styles.emptyState}>
        <svg className={styles.emptyIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M20 12v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6" />
          <polyline points="12 3 12 15" />
          <polyline points="8 7 12 3 16 7" />
        </svg>
        <p>Not enrolled yet. Set up Gift with Adoption to offer adopters a free Fi Mini.</p>
        <button type="button" className={styles.emptyCta} onClick={() => setModalDismissed(false)}>
          Set up now
        </button>
      </div>
      <GwaEnrollModal
        open={modalOpen}
        onClose={() => setModalDismissed(true)}
        onEnrolled={() => {
          setModalDismissed(true);
          refetch();
        }}
      />
    </div>
  );
}
